var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoundLog(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "96px",
    height: "96px",
    viewBox: "0 0 96 96",
    enableBackground: "new 0 0 96 96",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#DCDBDB",
    cx: 48,
    cy: 48,
    r: 46.983
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M57.1,51.25c-2.914,0-4.315,1.625-9.1,1.625s-6.175-1.625-9.1-1.625c-7.538,0.002-13.648,6.113-13.65,13.65 v4.225c0,2.693,2.183,4.875,4.875,4.875h35.75c2.692,0,4.875-2.182,4.875-4.875V64.9C70.748,57.363,64.638,51.252,57.1,51.25z  M67.5,69.125c-0.003,0.896-0.729,1.623-1.625,1.625h-35.75c-0.896-0.002-1.622-0.729-1.625-1.625V64.9 c0.004-5.742,4.658-10.396,10.4-10.4c1.99,0,3.971,1.625,9.1,1.625s7.109-1.625,9.1-1.625c5.742,0.004,10.396,4.658,10.4,10.4 V69.125z M48,48c7.18,0,13-5.82,13-13s-5.82-13-13-13s-13,5.82-13,13S40.82,48,48,48z M48,25.25c5.385,0,9.75,4.365,9.75,9.75 s-4.365,9.75-9.75,9.75s-9.75-4.365-9.75-9.75C38.259,29.619,42.619,25.259,48,25.25z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundLog);
export default __webpack_public_path__ + "static/media/round-log.63a5d8dc10f2e1784eb1e059f7b66e48.svg";
export { ForwardRef as ReactComponent };